import { render, staticRenderFns } from "./extra-neues-geraet-hinzufuegen.vue?vue&type=template&id=5b5bc240&lang=pug&"
import script from "./extra-neues-geraet-hinzufuegen.vue?vue&type=script&lang=js&"
export * from "./extra-neues-geraet-hinzufuegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports